import { FC } from 'react';
import SectionsList from '../../components/SectionsList/SectionsList';
import { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from 'src/view/components/Text/Text';

const DineInSections: FC = (): JSX.Element => {
  return (
    <div className="w-50 pr-6">
      <div className="d-flex align-items-center mb-4">
        <Text
          type={TEXT.SECTION_HEADER}
          text="table_management"
          tooltip={{ message: 'table_management_infotip', position: TOOLTIP_POSITION.FIXED, iconSize: 20 }}
        />
      </div>

      <SectionsList />
    </div>
  );
};

export default DineInSections;
